import Combobox from './combobox'
export default Combobox



/** WEBPACK FOOTER **
 ** ./es2015/controls/combobox/index.js
 **/